import { render, staticRenderFns } from "./GruposComponent.vue?vue&type=template&id=3951df88&scoped=true"
import script from "./GruposComponent.vue?vue&type=script&lang=js"
export * from "./GruposComponent.vue?vue&type=script&lang=js"
import style0 from "./GruposComponent.vue?vue&type=style&index=0&id=3951df88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951df88",
  null
  
)

export default component.exports